module.exports = __webpack_public_path__ + "static/media/release-plan.58423fa0.png";